import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withKeys as _withKeys, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../../assets/notSearchResult.svg'


const _withScopeId = n => (_pushScopeId("data-v-cdcdf738"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "member-wrapper" }
const _hoisted_2 = { class: "member-title" }
const _hoisted_3 = {
  key: 0,
  class: "member-title__container"
}
const _hoisted_4 = { class: "member-title__name" }
const _hoisted_5 = {
  key: 0,
  class: "member-title__container__operate-icon",
  title: "搜索成员"
}
const _hoisted_6 = {
  key: 1,
  class: "member-title__container"
}
const _hoisted_7 = { class: "list-container" }
const _hoisted_8 = {
  key: 0,
  class: "search-history"
}
const _hoisted_9 = { class: "search-history__head" }
const _hoisted_10 = { class: "search-history__body" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { class: "search-history__body__no-history" }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = ["onClick"]
const _hoisted_15 = {
  key: 0,
  class: "not-search-result"
}
const _hoisted_16 = { class: "not-search-result__tips" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "notSearchResult"
}, null, -1))
const _hoisted_18 = { class: "not-search-result__tips__text" }
const _hoisted_19 = {
  key: 0,
  class: "item-container"
}
const _hoisted_20 = { class: "item-container__title" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"display":"none"} }, null, -1))


const __default__ = {
  name: 'TeamHeadMemberList'
}

import {
  NPopover,
  NScrollbar,
  NDropdown,
  NInput,
  NButton,
  useMessage,
  InputInst
} from 'naive-ui'
import {
  ref,
  reactive,
  nextTick,
  Ref,
  computed,
  watch,
  HTMLAttributes,
  toRef,
  onMounted,
  onUnmounted
} from 'vue'
import Item from './item.vue'
import Icon from '@teams/common/components/icon'
import { useAppDialog } from '@/components/appDialog'
import DisableOrEnableMemberDailog from '@/components/dialog/disableOrEnableMember.vue'
import RemoveMemberDialog from '@/components/dialog/removeMember.vue'
import useTeamMember from '@teams/common/hooks/useTeamMember'
import { useGroupStore } from '@/store/group'
import { useUserStore } from '@/store/user'
import { useAcl } from 'vue-simple-acl'
import aclRules from '@teams/common/acl/aclRules'
import { useI18n } from 'vue-i18n'
import type { MemberItem as memberType } from '@teams/common/store/group'
import useSearchMember from '@teams/common/hooks/useSearchMember'
import MemberCard from './memberCard.vue'
type CurrentEdit = { type: string; id: number } | Record<string, unknown>


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props, { expose }) {

const { current, refreshGroupInfo } = useGroupStore()
const userStore = useUserStore()
const appDialog = useAppDialog()
const acl = useAcl()
const { memberList, memberGroups, memberManager, memberListManger, hasMore } =
  useTeamMember()
const { t } = useI18n()
const tBasePrefix = ref<string>('components.teamHead.memberList')
const refUserId = toRef(userStore, 'userId')

async function init() {
  await memberListManger.getMembers()
}

init()
const currentEdit = ref<CurrentEdit>({})
const updateCurrentEditItem = (val: CurrentEdit = {}) => {
  currentEdit.value = val
}
const searchText = ref('')
const inputRef = ref<InputInst | null>(null) // 暂停使用输入框 focus 效果
const isInputFocus = ref(false)
const refCurrentUserElement = ref<HTMLElement | null>(null)
const isDropDownToggleState = ref(false)
const popover = reactive({
  isShow: false,
  locked: false,
  async clickOutsize() {
    if (appDialog.visible.value || cardPopover.show) {
      return
    }
    popover.isShow = false
    popover.locked = true
    setTimeout(() => {
      popover.locked = false
    }, 200)
  },
  handleTrigger() {
    if (popover.locked) {
      return
    }
    // 非团队成员或访客能查看团队超管及以上角色成员时能打开面板
    popover.isShow =
      (!acl.can(aclRules.not_group_member) ||
        acl.can(aclRules.member_list_view_super_administor_higher_level)) &&
      !popover.isShow
  }
})

expose({
  handleTrigger: popover.handleTrigger
})
watch(popover, val => {
  if (!val.isShow) {
    updateCurrentEditItem()
  } else {
    refreshGroupInfo()
    memberListManger.reset()
  }
})

const cardPopover = reactive<{
  show: boolean
  showCard: boolean
  x: number
  y: number
  timer: undefined | ReturnType<typeof setTimeout>
  clickItem: memberType | null
  clickOutsize(): void
  showMemberCard(e: MouseEvent, it: memberType): void
  close(): void
}>({
  show: false,
  showCard: false,
  x: 0,
  y: 0,
  timer: undefined,
  clickItem: null,
  close() {
    cardPopover.show = false
    cardPopover.showCard = false
    cardPopover.clickItem = null
  },
  async clickOutsize() {
    cardPopover.timer = setTimeout(() => {
      cardPopover.close()
    }, 200)
  },
  showMemberCard(event: MouseEvent, item) {
    if (acl.can(aclRules.not_group_member)) {
      return
    }
    // 不管是否左键当前成员，都是先关闭右键弹窗，再次点击才打开左边弹窗
    if (isDropDownToggleState.value) {
      isDropDownToggleState.value = false
      return
    }
    if (item.id === cardPopover?.clickItem?.id || !!currentEdit.value.id) {
      cardPopover.show = false
      return
    }
    clearTimeout(cardPopover.timer)
    const target = event.currentTarget as HTMLElement
    if (!target) {
      return
    }
    const { x, y } = target.getBoundingClientRect()
    cardPopover.x = x
    cardPopover.y = y
    cardPopover.clickItem = item
    cardPopover.show = true
    cardPopover.showCard = false
    nextTick().then(() => {
      cardPopover.showCard = true
    })
  }
})
// 获取当前用户在成员列表里的dom元素
const refCurrentUser = (memberComponent, member) => {
  const { id } = member
  if (id === userStore.userId) {
    refCurrentUserElement.value = memberComponent?.$el?.parentNode
  }
}
const useMemberContextMenu = ({
  selected,
  handleError = () => null,
  refUserId
}: {
  selected: Ref<memberType | null>
  handleError?: (...args: unknown[]) => unknown
  refUserId: Ref<number | undefined>
}) => {
  const visible = ref(false)
  const updateVisible = (val = true, clearSelected = false) => {
    visible.value = val
    if (!val && clearSelected) {
      updateSelected()
    }
  }
  const updateSelected = (val: null | memberType = null) => {
    selected && (selected.value = val)
  }
  // 选中的是否为自己
  const isSelectedSelf = computed(() => {
    return refUserId.value === selected.value?.id
  })
  const x = ref(0)
  const y = ref(0)
  // 选中成员的角色等级是否小于自己
  const isSelectedLowerThanMe = computed(() => {
    return acl.can(aclRules.is_lower_level_than_me, [selected.value])
  })
  const MENU_KEYS = {
    updateNickname: 'updateNickname',
    updateSign: 'updateSign',
    changeMemberRole: 'changeMemberRole',
    disableMember: 'disableMember',
    enableMember: 'enableMember',
    removeMember: 'removeMember'
  }
  const menuList: Array<{
    label?: string
    key: string
    enable?: () => boolean
    getChildren?: () => unknown[]
    children?: unknown[]
    type?: string
    props?: HTMLAttributes
  }> = [
    {
      label: '修改空间内昵称',
      key: MENU_KEYS.updateNickname,
      enable() {
        return (
          (isSelectedSelf.value &&
            acl.can(aclRules.member_list_update_nickname)) ||
          (acl.can(aclRules.member_list_update_lower_level_nickname) &&
            isSelectedLowerThanMe.value)
        )
      }
    },
    {
      label: '修改签名',
      key: MENU_KEYS.updateSign,
      enable() {
        return (
          (isSelectedSelf.value && acl.can(aclRules.member_list_update_sign)) ||
          (acl.can(aclRules.member_list_update_lower_level_sign) &&
            isSelectedLowerThanMe.value)
        )
      }
    },
    {
      label: '修改角色',
      key: MENU_KEYS.changeMemberRole,
      enable: () => {
        return (
          acl.can(aclRules.member_list_update_lower_level_role) &&
          isSelectedLowerThanMe.value
        )
      },
      getChildren: () => {
        return memberManager.getChangeableRoleList(selected.value).map(it => {
          return {
            ...it,
            operate: MENU_KEYS.changeMemberRole
          }
        })
      }
    },
    {
      type: 'divider',
      key: 'd1'
    },
    {
      label: '禁用成员',
      key: MENU_KEYS.disableMember,
      enable() {
        return (
          !selected.value?.disabled &&
          acl.can(aclRules.member_list_disable_lower_level) &&
          isSelectedLowerThanMe.value
        )
      },
      props: {
        class: 'special-color'
      }
    },
    {
      label: '启用成员',
      key: MENU_KEYS.enableMember,
      enable() {
        return (
          !!selected.value?.disabled &&
          acl.can(aclRules.member_list_disable_lower_level) &&
          isSelectedLowerThanMe.value
        )
      }
    },
    {
      label: '移除成员',
      key: MENU_KEYS.removeMember,
      enable() {
        return (
          acl.can(aclRules.member_list_remove_lower_level) &&
          isSelectedLowerThanMe.value
        )
      },
      props: {
        class: 'special-color'
      }
    }
  ]
  const menus = computed(() => {
    if (!selected.value) {
      return []
    }
    // 过滤不能显示的菜单
    const res = menuList.filter(menu => {
      let flag = true
      if (menu.enable) {
        flag = menu.enable()
      }
      // children为空时不显示
      if (flag && menu.getChildren) {
        const children = menu.getChildren()
        flag = !!children.length
        flag && (menu.children = children)
      }
      return flag
    })
    // 判断是否展示d1
    const len = res.length - 1
    if (res[len].key === 'd1') {
      res.pop()
    }
    return res
  })

  type getMenuKeyTypeHelper<T> = T extends Ref<infer V> ? V : never
  type getMenuKeyType<T> = T extends Array<{
    key: infer V
    children?: infer U
    label: string
  }>
    ? V | getMenuKeyType<U>
    : never
  type menuKeyUnion = getMenuKeyType<getMenuKeyTypeHelper<typeof menus>>
  // 右键菜单，设置xy,selected
  const handleShow = (e: MouseEvent, item: memberType) => {
    e.preventDefault()
    if (searchShow.value) {
      searchHistoryManager.saveSearchHistory(searchText.value)
    }
    updateVisible(false)
    updateSelected(item)
    nextTick().then(() => {
      if (!menus.value.length) {
        return
      }
      x.value = e.clientX
      y.value = e.clientY
      updateVisible(true)
    })
  }
  const handleClose = () => {
    updateVisible(false)
  }
  const handleClickoutside = () => {
    updateVisible(false)
  }

  // 移除成员
  const removeGroupMember = async member => {
    const { nickname, user_name: userName, userId } = member
    const name = nickname !== '' ? nickname : userName
    if (member) {
      try {
        appDialog.show({
          title: '移除成员',
          component: RemoveMemberDialog,
          footer: false,
          componentProps: {
            type: 'disable',
            name: name,
            async onConfirm() {
              await memberManager.remove([userId])
              if (searchShow.value) {
                removeSearchMember(member.id)
              }
              appDialog.close()
            }
          },
          size: 'small'
        })
      } catch (e) {
        handleError(e)
      }
    }
  }

  // 修改昵称
  const updateNickname = () => {
    updateCurrentEditItem({
      type: 'nickname',
      id: selected.value?.id
    })
  }
  // 修改签名
  const updateSign = () => {
    updateCurrentEditItem({
      type: 'sign',
      id: selected.value?.id
    })
  }
  // 禁用成员
  const disableOrEnableMember = (member, type) => {
    console.log(member, 'member')
    const { nickname, user_name: userName, userId } = member
    const name = nickname !== '' ? nickname : userName
    const isDisable = type === 'disable'
    appDialog.show({
      title: isDisable ? '禁用成员' : '启用成员',
      component: DisableOrEnableMemberDailog,
      footer: false,
      componentProps: {
        type: type,
        name: name,
        async onConfirm() {
          try {
            isDisable
              ? await memberManager.disable(userId)
              : await memberManager.enable(userId)
            if (searchShow.value) {
              updateSearchMember(userId)
            }
            appDialog.close()
          } catch (e) {
            handleError(e)
          }
        }
      },
      size: 'small'
    })
  }
  // 修改用户角色
  const changeMemberRole = async roleId => {
    const userId = selected.value?.id
    if (userId) {
      try {
        await memberManager.changeRole(userId, roleId)
        if (searchShow.value) {
          updateSearchMember(userId)
        }
      } catch (e) {
        handleError(e)
      }
    }
  }

  const handleSelect = async (key: menuKeyUnion, option) => {
    const operate = option.operate || key
    switch (operate) {
      case MENU_KEYS.updateNickname:
        await updateNickname()
        break
      case MENU_KEYS.updateSign:
        await updateSign()
        break
      case MENU_KEYS.disableMember:
        await disableOrEnableMember(selected.value, 'disable')
        break
      case MENU_KEYS.enableMember:
        await disableOrEnableMember(selected.value, 'enable')
        break
      case MENU_KEYS.changeMemberRole:
        await changeMemberRole(option.value)
        break
      case MENU_KEYS.removeMember:
        await removeGroupMember(selected.value)
        break
      default:
        break
    }
    // 点击修改昵称/签名，先不清空选中
    const clearSelected = ![
      MENU_KEYS.updateNickname,
      MENU_KEYS.updateSign
    ].includes(key)
    updateVisible(false, clearSelected)
  }
  // 输入框输入完成
  const inputDone = async text => {
    const { nickname, sign, userId } = selected.value || {}
    const { type, id } = currentEdit.value
    const isUpdateNickname = type === 'nickname'
    const originValue = isUpdateNickname ? nickname : sign
    updateCurrentEditItem()
    if (text === originValue || !id) {
      return
    }
    /*     if (!text) {
      message.warning('修改内容不能为空')
      return
    } */
    isUpdateNickname
      ? ((selected.value as memberType).nickname = text)
      : ((selected.value as memberType).sign = text)
    try {
      if (isUpdateNickname) {
        await memberManager.updateNickname(userId as number, text)
      } else {
        await memberManager.updaetSign(userId as number, text)
      }
      if (searchShow.value) {
        updateSearchMember(userId)
      }
    } catch (e) {
      handleError(e)
      await memberListManger.refresh()
      if (searchShow.value) {
        updateSearchMember(userId)
      }
    }
    updateSelected()
  }
  return reactive({
    visible,
    handleShow,
    handleClose,
    handleClickoutside,
    handleSelect,
    updateSelected,
    inputDone,
    MENU_KEYS,
    x,
    y,
    menus
  })
}
const handleScroll = e => {
  const target: HTMLElement = e.target
  cardPopover.close()
  popoverContextMenu.handleClose()
  const { offsetHeight, scrollTop, scrollHeight } = target
  if (offsetHeight + scrollTop >= scrollHeight - 50) {
    //   滚动到底部加载更多成员
    memberListManger.getMembers()
  }
}

const selectedMember = ref<memberType | null>(null)
const message = useMessage()
const popoverContextMenu = useMemberContextMenu({
  selected: selectedMember,
  handleError: (error: unknown) => {
    const responseMsg = (
      error as undefined | { response: { data: { msg: string } } }
    )?.response?.data?.msg
    if (responseMsg) {
      message.error(responseMsg)
    } else {
      message.error('内部错误')
    }
  },
  refUserId
})
watch(
  () => popoverContextMenu.visible,
  (_newValue, oldValue) => {
    if (oldValue) {
      isDropDownToggleState.value = true
    }
  }
)
// 右上角更多菜单
const moreMenu = reactive({
  options: computed(() => {
    return [
      {
        label: t(`${tBasePrefix.value}.modifyMyTeamNickname`),
        key: popoverContextMenu.MENU_KEYS.updateNickname
      },
      {
        label: t(`${tBasePrefix.value}.modifyMySignature`),
        key: popoverContextMenu.MENU_KEYS.updateSign
      }
    ]
  }),
  select(key, option) {
    switch (key) {
      case popoverContextMenu.MENU_KEYS.updateNickname:
      case popoverContextMenu.MENU_KEYS.updateSign:
        moreMenu.updateNicknameOrSign(option)
        break
      default:
        break
    }
  },
  async findMe() {
    const member = memberList.value.find(it => it.id === userStore.userId)
    if (!member && hasMore) {
      await memberListManger.getMembers()
      return moreMenu.findMe()
    }
    return member
  },
  async updateNicknameOrSign(option) {
    const member = await moreMenu.findMe()
    if (member) {
      await nextTick()
      if (refCurrentUserElement.value) {
        refCurrentUserElement.value.scrollIntoView()
      }
      popoverContextMenu.updateSelected(member)
      popoverContextMenu.handleSelect(option.key, option)
    }
  }
})
// 搜索功能
const {
  searchShow,
  updateSearchShow,
  searchResultGroups,
  searchHistoryManager,
  searchHistory,
  debounceSearch,
  updateSearchMember,
  removeSearchMember
} = useSearchMember()

// rbac搜索入口
const rbacSearchEntry = computed(() => {
  return acl.can(aclRules.member_list_search_visibility)
})
// 手动输入搜索
const handleSearchInput = async (inputValue: string) => {
  if (!inputValue) return
  await debounceSearch(inputValue)
}
// 输入框状态的改变
const onInputFocusChange = () => {
  isInputFocus.value = !isInputFocus.value
}
// 自动输入搜索
const autoInputSearch = async (inputValue: string) => {
  searchText.value = inputValue
  await handleSearchInput(inputValue)
}
// 打开搜索页面
const openSearchPage = async () => {
  searchHistoryManager.getSearchHistory()
  updateSearchShow(true)
  await nextTick()
  searchText.value = ''
  inputRef.value?.focus()
}
// 关闭搜索页面
const closeSearchPage = (e: Event) => {
  e.stopPropagation()
  searchText.value = ''
  updateSearchShow(false)
}
// 删除某条记录
const handleDeleteHistory = async (value: string) => {
  await searchHistoryManager.deleteSearchHistory(value)
}

// 监听成员列表状态的变化
watch(
  () => popover.isShow,
  (newValue, _oldValue) => {
    if (!newValue && searchShow.value) {
      setTimeout(() => {
        updateSearchShow(false)
      }, 200)
    }
  }
)
const onEscCloseDialog = (e: KeyboardEvent) => {
  if (e.key === 'Escape' && popover.isShow) {
    popover.clickOutsize()
  }
}
onMounted(() => {
  window.addEventListener('keyup', onEscCloseDialog)
})
onUnmounted(() => {
  window.removeEventListener('keyup', onEscCloseDialog)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(NPopover), {
      trigger: "manual",
      placement: "bottom-end",
      show: popover.isShow,
      "show-arrow": false,
      class: "popover-member-list",
      onClickoutside: popover.clickOutsize,
      style: {"background-color":"var(--background-01)","color":"var(--text-01)","border-radius":"12px","box-shadow":"var(--shadow-02)"}
    }, {
      trigger: _withCtx(() => [
        _renderSlot(_ctx.$slots, "trigger", {
          clickTrigger: popover.handleTrigger
        })
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            (!_unref(searchShow))
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(t)(`${tBasePrefix.value}.teamMembers`)) + "(" + _toDisplayString(_unref(current).memberCount) + ") ", 1),
                  (_unref(rbacSearchEntry))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                        _createVNode(_unref(Icon), {
                          name: "search",
                          size: 16,
                          onClick: openSearchPage
                        })
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _createVNode(_unref(NInput), {
                    ref_key: "inputRef",
                    ref: inputRef,
                    placeholder: _unref(t)(`${tBasePrefix.value}.searchForTeamMembers`),
                    value: searchText.value,
                    "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((searchText).value = $event)),
                    class: "searchMember",
                    onInput: handleSearchInput,
                    onKeyup: _cache[1] || (_cache[1] = _withKeys(e => closeSearchPage(e), ["esc"])),
                    onFocus: onInputFocusChange,
                    onBlur: onInputFocusChange,
                    style: _normalizeStyle({
              backgroundColor: isInputFocus.value
                ? 'var(--ctl-background-02)'
                : 'var(--ctl-background-01)'
            })
                  }, {
                    prefix: _withCtx(() => [
                      _createVNode(_unref(Icon), {
                        name: "search",
                        size: 16
                      })
                    ]),
                    _: 1
                  }, 8, ["placeholder", "value", "style"]),
                  _createVNode(_unref(NButton), {
                    text: "",
                    onClick: _cache[2] || (_cache[2] = e => closeSearchPage(e)),
                    class: "member-title__container__btn-cancel"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(t)(`${tBasePrefix.value}.cancel`)), 1)
                    ]),
                    _: 1
                  })
                ]))
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_unref(NScrollbar), {
              style: {"max-height":"100%"},
              onScroll: handleScroll
            }, {
              default: _withCtx(() => [
                (_unref(searchShow) && !searchText.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                      _createElementVNode("div", _hoisted_9, [
                        _createElementVNode("span", null, _toDisplayString(_unref(t)(`${tBasePrefix.value}.searchHistory`)), 1),
                        (_unref(searchHistory).length > 0)
                          ? (_openBlock(), _createElementBlock("span", {
                              key: 0,
                              class: "search-history__head__suf-text",
                              onClick: _cache[3] || (_cache[3] = () => _unref(searchHistoryManager).emptySearchHistory())
                            }, _toDisplayString(_unref(t)(`${tBasePrefix.value}.empty`)), 1))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_10, [
                        (!_unref(searchHistory).length)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                              _createElementVNode("p", _hoisted_12, _toDisplayString(_unref(t)(`${tBasePrefix.value}.noSearchHistory`)), 1)
                            ]))
                          : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_unref(searchHistory), (item, index) => {
                              return (_openBlock(), _createElementBlock("li", {
                                class: "search-history__body__list",
                                key: index
                              }, [
                                _createElementVNode("span", {
                                  onClick: ($event: any) => (autoInputSearch(item))
                                }, _toDisplayString(item), 9, _hoisted_13),
                                _createElementVNode("div", {
                                  class: "search-history__body__list__icon",
                                  onClick: ($event: any) => (handleDeleteHistory(item))
                                }, [
                                  _createVNode(_unref(Icon), {
                                    name: "deleteHistory",
                                    size: 12,
                                    fill: "transparent"
                                  })
                                ], 8, _hoisted_14)
                              ]))
                            }), 128))
                      ])
                    ]))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      (
                _unref(searchShow) &&
                !Object.keys(_unref(searchResultGroups)).length &&
                searchText.value
              )
                        ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                            _createElementVNode("div", _hoisted_16, [
                              _hoisted_17,
                              _createElementVNode("span", _hoisted_18, _toDisplayString(_unref(t)(`${tBasePrefix.value}.noRelevantSearchResults`)), 1)
                            ])
                          ]))
                        : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_unref(searchShow) ? _unref(searchResultGroups) : _unref(memberGroups), (group) => {
                            return (_openBlock(), _createElementBlock(_Fragment, {
                              key: group.roleId
                            }, [
                              (group.list.length > 0)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                                    _createElementVNode("div", _hoisted_20, _toDisplayString(group.title), 1),
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.list, (item) => {
                                      return (_openBlock(), _createElementBlock("div", {
                                        key: item.id,
                                        class: _normalizeClass(["item-container__item-wrap", {
                        'item-container__item-wrap-active':
                          (item.id === selectedMember.value?.id &&
                            _unref(popoverContextMenu).visible) ||
                          (item.id === cardPopover.clickItem?.id &&
                            cardPopover.show)
                      }])
                                      }, [
                                        _createVNode(Item, {
                                          ref_for: true,
                                          ref: el => refCurrentUser(el, item),
                                          item: item,
                                          isCurrentAccount: item.userId === _unref(refUserId),
                                          edit: currentEdit.value,
                                          searchShow: _unref(searchShow),
                                          onInputDone: _unref(popoverContextMenu).inputDone,
                                          onMemberLeftClick: _cache[4] || (_cache[4] = 
                          () =>
                            _unref(searchHistoryManager).saveSearchHistory(searchText.value)
                        ),
                                          onContextmenu: (e) => _unref(popoverContextMenu).handleShow(e, item),
                                          onClickItem: e => cardPopover.showMemberCard(e, item)
                                        }, null, 8, ["item", "isCurrentAccount", "edit", "searchShow", "onInputDone", "onContextmenu", "onClickItem"])
                                      ], 2))
                                    }), 128))
                                  ]))
                                : _createCommentVNode("", true)
                            ], 64))
                          }), 128))
                    ], 64))
              ]),
              _: 1
            })
          ]),
          _createVNode(_unref(NDropdown), {
            placement: "bottom-start",
            trigger: "manual",
            x: _unref(popoverContextMenu).x,
            y: _unref(popoverContextMenu).y,
            options: _unref(popoverContextMenu).menus,
            show: _unref(popoverContextMenu).visible,
            "on-clickoutside": _unref(popoverContextMenu).handleClickoutside,
            onSelect: _unref(popoverContextMenu).handleSelect,
            class: "dropdown--default member-list__dropdown"
          }, null, 8, ["x", "y", "options", "show", "on-clickoutside", "onSelect"])
        ])
      ]),
      _: 3
    }, 8, ["show", "onClickoutside"]),
    _createVNode(_unref(NPopover), {
      trigger: "manual",
      placement: "left-start",
      show: cardPopover.show,
      "show-arrow": false,
      x: cardPopover.x,
      y: cardPopover.y,
      class: "popover-member-card",
      style: {"background-color":"var(--background-01)","color":"var(--text-01)"},
      onClickoutside: cardPopover.clickOutsize
    }, {
      trigger: _withCtx(() => [
        _hoisted_21
      ]),
      default: _withCtx(() => [
        (cardPopover.showCard)
          ? (_openBlock(), _createBlock(MemberCard, {
              key: 0,
              item: cardPopover.clickItem
            }, null, 8, ["item"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["show", "x", "y", "onClickoutside"])
  ], 64))
}
}

})